import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
  label?: string;
  variant?: 'dark' | 'light';
}
export function CountdownTimer({
  className = '',
  label,
  variant = 'dark'
}: CountdownTimerProps) {
  // Initialize with 24 hours in seconds if not in localStorage
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem('snugges-timer');
    if (saved) {
      const parsed = parseInt(saved, 10);
      // If timer is expired or invalid, reset to 24h
      if (isNaN(parsed) || parsed <= 0) return 24 * 60 * 60;
      return parsed;
    }
    return 24 * 60 * 60; // 24 hours
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        const newTime = prev > 0 ? prev - 1 : 24 * 60 * 60;
        localStorage.setItem('snugges-timer', newTime.toString());
        return newTime;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  const boxClass = variant === 'dark' ? 'bg-white text-[#9AC1F0]' : 'bg-[#9AC1F0] text-white';
  const labelClass = variant === 'dark' ? 'text-white/90' : 'text-[#9AC1F0]';
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-54">
      {label && <span className={`text-sm font-bold uppercase tracking-wider ${labelClass}`} data-id="element-55">
          {label}
        </span>}
      <div className="flex items-center gap-1 font-mono font-bold" data-id="element-56">
        <div className={`rounded px-2 py-1 min-w-[2.5rem] text-center ${boxClass}`} data-id="element-57">
          {formatTime(hours)}
        </div>
        <span className={variant === 'dark' ? 'text-white' : 'text-[#9AC1F0]'} data-id="element-58">
          :
        </span>
        <div className={`rounded px-2 py-1 min-w-[2.5rem] text-center ${boxClass}`} data-id="element-59">
          {formatTime(minutes)}
        </div>
        <span className={variant === 'dark' ? 'text-white' : 'text-[#9AC1F0]'} data-id="element-60">
          :
        </span>
        <div className={`rounded px-2 py-1 min-w-[2.5rem] text-center ${boxClass}`} data-id="element-61">
          {formatTime(seconds)}
        </div>
      </div>
    </div>;
}